<template lang="pug">
section.section(:class="[sectionColor, sectionAlign]")
	.section__wrapper
		h2.section__title(v-if="hasTitle") {{ title }}
		.section__content
			slot
</template>

<script>
export default {
	name: 'SectionLayout',
	props: {
		color: String,
		title: {
			type: String,
			default: ''
		},
		align: String
	},
	computed: {
		hasTitle() {
			return this.title.trim() !== ''
		},
		sectionColor() {
			if(!this.color) return ''
			return 'section_' + this.color
		},
		sectionAlign() {
			if(!this.align) return ''
			return 'section_align-' + this.align
		}
	}
}
</script>

<style lang="sass" scoped>
@import '@/assets/style/components/SectionLayout.sass'
</style>


// WEBPACK FOOTER //
// src/components/SectionLayout.vue